module.exports = __webpack_public_path__ + "static/media/bulldog.a094f8ed.png";